module.exports = __webpack_public_path__ + "static/media/Banner-survey.5325292e.jpg";